export enum DISTANCE_OPTIONS {
  OPTION_1 = "0 - 5 miles",
  OPTION_2 = "5 - 10 miles",
  OPTION_3 = "10 - 30 miles",
  OPTION_4 = "more than 30 miles"
}
